// @flow
import * as React from 'react'
import { Text } from 'core/Text'
import Link from 'ui/Link'
import { DesktopMediaQuery, MobileMediaQuery } from 'ui/MediaQuery'
import schoolVanityUrl from 'urls/school_vanity'
import { applyImageProcessing } from 'util/uploadcare'
import type { SchoolData } from './Query'

import './Header.module.scss'

type Props = {
  school: SchoolData,
}

export default function Header(props: Props) {
  const { school } = props

  return (
    <div styleName="container">
      <div>
        <div styleName="image" style={imageStyle(school)} />
      </div>

      <div>
        <Text bold>
          <DesktopMediaQuery>{school.name}</DesktopMediaQuery>
          <MobileMediaQuery>
            <Link href={schoolVanityUrl(school)}>{school.name}</Link>
          </MobileMediaQuery>
        </Text>
        <Text color="gray">{(school.director && school.director.name) || null}</Text>
      </div>

      <div styleName="spacing" />

      <DesktopMediaQuery>
        <Link href={schoolVanityUrl(school)}>Return to School Page</Link>
      </DesktopMediaQuery>
    </div>
  )
}

function imageStyle(school) {
  return { backgroundImage: `url(${imageUrl(school)})` }
}

function imageUrl(school) {
  const url = school.director && school.director.avatarUrl
  if (!url) return ''

  return applyImageProcessing(url, [{ format: 'auto' }, { scaleCrop: '100x100/center' }])
}
